import { useMemo } from 'react'
import { useGetCategories } from 'src/hooks/useGetCategories'
import { CATEGORY_TYPE } from 'src/libs/constant'
export function CategoryColumn ({ type, id }) {
  const categories = useGetCategories(type)
  const category = useMemo(() => {
    return categories?.find?.((item) => item.id === id)
  }, [type, id, categories])
  if(type === CATEGORY_TYPE.LEVEL) {
    return <div style={{ color: colorLevel[category?.code], fontWeight: '500' }}>{category?.name || ''}</div>
  }
  return <>{category?.name || ''}</>
}

const colorLevel = {
  "": "",
  LEVEL_A: "#26A316",
  LEVEL_B: "#0C6496",
  LEVEL_C: "#FB8500",
  LEVEL_D: "#DC2632",
}